module.exports = new __parcel__URL__("lock-closed.22dbfd6e.svg").toString();